module.exports = __webpack_public_path__ + "03a869cb3135599ced260d3bd0a8ce21.png";


//////////////////
// WEBPACK FOOTER
// ./js/sport-betting/components/games/slots/tomhorn/assets/149.png
// module id = 1744
// module chunks = 2